import type { ReactNode } from "react";

export function ArrowPrevIcon(): ReactNode {
	return (
		<svg fill="none" height="8" viewBox="0 0 5 8" width="5" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M1.50727 4.00149L4.81645 7.02642C5.06118 7.25032 5.06118 7.61236 4.81645 7.83387C4.57171 8.05538 4.17596 8.05538 3.93122 7.83387L0.182038 4.4064C-0.0548897 4.18965 -0.0600972 3.84191 0.163813 3.61801L3.92862 0.166728C4.05099 0.0547824 4.21241 0 4.37123 0C4.53005 0 4.69147 0.0547824 4.81384 0.166728C5.05858 0.390622 5.05858 0.752661 4.81384 0.974172L1.50727 4.00149Z"
				fill="currentColor"
			/>
		</svg>
	);
}
